import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute top-0 z-50 flex flex-col items-center justify-center w-full h-full space-y-4 bg-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "loading" }, null, -1)
const _hoisted_3 = { class: "text-lg font-bold text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.message), 1)
  ]))
}